import { alpha } from "@mui/material/styles";
import { TEXT_VARIANT_MAPPING } from "../types";
export const componentOverrides = (paletteDefinitions, alphaDefinitions) => ({
    Avatar: {
        defaultProps: {
            size: "large",
            tooltip: false,
            color: "surface",
            colorSet: "container",
        },
    },
    NavigationRail: {
        defaultProps: {
            color: "surface",
            colorSet: "container",
        },
    },
    Badge: {
        defaultProps: {
            placement: {
                horizontal: "right",
                vertical: "top",
            },
            color: "surface",
        },
    },
    MuiTypography: {
        defaultProps: {
            variantMapping: TEXT_VARIANT_MAPPING,
        },
    },
    MuiCssBaseline: {
        styleOverrides: {
            body: {
                backgroundColor: paletteDefinitions?.background?.main,
                color: paletteDefinitions?.background?.onMain,
            },
            "::-webkit-scrollbar": {
                width: 6,
                height: 6,
            },
            "::-webkit-scrollbar-track": {
                backgroundColor: paletteDefinitions?.stroke?.[50],
            },
            "::-webkit-scrollbar-thumb": {
                backgroundColor: paletteDefinitions?.stroke?.[200],
                borderRadius: 8,
            },
            "::-webkit-scrollbar-thumb:hover": {
                backgroundColor: paletteDefinitions?.stroke?.[200],
            },
        },
    },
    MuiContainer: {
        styleOverrides: {
            root: {
                "@media (min-width: 600px)": {
                    paddingLeft: "32px",
                    paddingRight: "32px",
                },
            },
            disableGutters: {
                paddingLeft: `${0} !important`,
                paddingRight: `${0} !important`,
            },
        },
    },
    MuiMenuItem: {
        styleOverrides: {
            root: {
                "&.Mui-selected": {
                    backgroundColor: alpha(paletteDefinitions?.background?.onMain || "#000000", alphaDefinitions?.active || 0.8),
                    "&:hover": {
                        backgroundColor: alpha(paletteDefinitions?.background?.onMain || "#000000", alphaDefinitions?.active || 0.8),
                    },
                },
            },
        },
    },
    MuiAutocomplete: {
        styleOverrides: {
            root: {
                "&.Mui-selected": {
                    backgroundColor: alpha(paletteDefinitions?.background?.onMain || "#000000", alphaDefinitions?.active || 0.8),
                    "&:hover": {
                        backgroundColor: alpha(paletteDefinitions?.background?.onMain || "#000000", alphaDefinitions?.active || 0.8),
                    },
                },
            },
        },
    },
});
//# sourceMappingURL=components.js.map